export default "__VITE_ASSET__50ab1b43__"